import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { DashboardPage } from "@/features/dashboards/DashboardPage";
import { RANGES } from "@/features/dashboards/route-params";

const search = z.object({ range: z.enum(RANGES).optional() });

export const Route = createFileRoute("/_app/dashboards/$dashboard")({
  validateSearch: search,
  component: Page,
});

function Page() {
  const { dashboard } = Route.useParams();
  return <DashboardPage id={dashboard} search={Route.useSearch()} />;
}
